import { IPostBody } from 'src/types/PostBody';
import { IReceipt } from 'src/types/Receipt';
import axios from 'src/utils/axios';

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/store';
type receiptInputParams = { data: IPostBody; companyId?: string };

export const fetchReceiptGridData = createAsyncThunk(
  'receipt/fetchReceiptGridData',
  async ({ data, companyId }: receiptInputParams) => {
    const response = await axios.post(`/receipt/filter`, data, {
      params: { companyId: companyId },
    });
    return response.data;
  }
);

interface gridReceiptDataState {
  receiptData: IReceipt[];
  receiptTotal: number;
  recLoading: 'pending' | 'succeeded' | 'failed';
}

const initialState = {
  receiptData: [],
  receiptTotal: 0,
  recLoading: 'pending',
} as gridReceiptDataState;

export const receiptGridSlice = createSlice({
  name: 'receipt',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        fetchReceiptGridData.fulfilled,
        (state, action: PayloadAction<{ items: IReceipt[]; totalRecords: number }>) => {
          state.receiptData = action.payload.items;
          state.receiptTotal = action.payload.totalRecords;
          state.recLoading = 'succeeded';
        }
      )
      .addCase(fetchReceiptGridData.rejected, (state) => {
        state.recLoading = 'failed';
      })
      .addCase(fetchReceiptGridData.pending, (state) => {
        state.recLoading = 'pending';
      });
  },
});

export const selectReceiptUse = (state: RootState) => state.receipts;
export default receiptGridSlice.reducer;
